import React from "react";
import { useNavigate } from "react-router-dom";
import { PageLayout } from "../../app/PageLayout";
import { Button, Card, Field, Input, RadioCards } from "../../components/ui";
import { useSession } from "../../context/SessionContext";
import { t } from "../../i18n";
import { useSurgicalIndication } from "./useSurgicalIndication";
import { PATHS } from "../../app/paths";

// "yyyy-mm-ddThh:mm" no fuso local, formato do min de datetime-local.
const nowLocal = () => {
  const d = new Date();
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().slice(0, 16);
};

export const SurgicalIndicationPage: React.FC = () => {
  const form = useSurgicalIndication();
  const { metadata } = useSession();
  const navigate = useNavigate();

  return (
    <PageLayout
      title={t("surgicalIndication.title")}
      onBack={() => navigate(PATHS.opme)}
      nav={false}
      cta={
        <Button variant="primary" size="lg" loading={form.loading} disabled={!form.canSubmit} onClick={form.submit}>
          {t("surgicalIndication.confirm")}
        </Button>
      }
      ctaHint={form.canSubmit ? undefined : form.dateError ?? t("surgicalIndication.missing")}
    >
      <Card>
        <div className="flex flex-col gap-3">
          <Field label={t("surgicalIndication.hospital")} hint={t("surgicalIndication.hospitalHint")}>
            <Input
              value={form.hospital}
              onChange={(e) => form.setHospital(e.target.value)}
              placeholder={t("surgicalIndication.hospitalPlaceholder")}
              list="linked-hospitals"
              autoComplete="off"
            />
          </Field>
          <datalist id="linked-hospitals">
            {metadata.hospitals.map((h) => (
              <option key={h.id} value={h.name} />
            ))}
          </datalist>
          <Field label={t("surgicalIndication.date")} error={form.dateError}>
            <Input type="datetime-local" min={nowLocal()} value={form.desiredDate} onChange={(e) => form.setDesiredDate(e.target.value)} />
          </Field>
          <RadioCards
            label={t("surgicalIndication.surgery")}
            value={form.surgery}
            onChange={form.setSurgery}
            options={[
              { value: "Eletiva", title: t("surgicalIndication.elective") },
              { value: "Emergência", title: t("surgicalIndication.emergency") },
            ]}
          />
        </div>
      </Card>
    </PageLayout>
  );
};
